import { setSpecificMessage, endsWith } from "valibot";
setSpecificMessage(
  endsWith,
  (issue) => `Fin invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);